import React, { useEffect } from "react";
import { Modal, Table } from "react-bootstrap";
import Colors from "Constants/Color";
import { tableStyles } from "Constants/Style";
import CancelBackButton from "components/Buttons/CancelBackButton";

interface Bag {
  bag_no: string;
  status?: "verified" | "not_verified" | null;
  total_quantity: number;
  dispatch_quantity: number;
  inventory_item_id?: string;
}

interface ViewBagsModalProps {
  show: boolean;
  handleClose: () => void;
  bags: Bag[];
  itemName?: string;
}

const ViewBagsModal: React.FC<ViewBagsModalProps> = ({
  show,
  handleClose,
  bags = [],
  itemName,
}) => {
  const getStatusBadge = (status: "verified" | "not_verified" | null | undefined) => {
    if (!status) {
      return (
        <span
          style={{
            backgroundColor: Colors?.bg_gray || "#6c757d",
            color: "white",
            padding: "4px 12px",
            borderRadius: "4px",
            fontSize: "12px",
            textTransform: "capitalize",
            fontWeight: "500",
          }}
        >
          Not Verified
        </span>
      );
    }

    const isVerified = status === "verified";
    return (
      <span
        style={{
          backgroundColor: isVerified ? Colors?.bg_green || "#28a745" : Colors?.bg_damage || "#dc3545",
          color: "white",
          padding: "4px 12px",
          borderRadius: "4px",
          fontSize: "12px",
          textTransform: "capitalize",
          fontWeight: "500",
        }}
      >
        {isVerified ? "Verified" : "Not Verified"}
      </span>
    );
  };


  useEffect(()=>{
    console.log("Bags",bags)
  },bags)

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header className="border-0">
        <Modal.Title className="fw-bold">
          {itemName ? `Bag Details - ${itemName}` : "Bag Details"}
        </Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={handleClose}
        />
      </Modal.Header>
      <hr />
      <Modal.Body>
        {bags.length === 0 ? (
          <div className="text-center py-4 text-muted">
            No bags available for this item.
          </div>
        ) : (
          <Table responsive className="align-middle">
            <thead className="table-light border-bottom">
              <tr>
                <th style={{ ...tableStyles.headerAlt, minWidth: 70 }} className="py-3 px-3">
                  Sr No.
                </th>
                <th style={{ ...tableStyles.headerAlt, minWidth: 200 }} className="py-3 px-3">
                  Bag No.
                </th>
                <th style={{ ...tableStyles.headerAlt, minWidth: 150 }} className="py-3 px-3">
                  Total Quantity
                </th>
                <th style={{ ...tableStyles.headerAlt, minWidth: 150 }} className="py-3 px-3">
                  Issued Quantity
                </th>
                <th style={{ ...tableStyles.headerAlt, minWidth: 150 }} className="py-3 px-3">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {bags.map((bag, idx) => (
                <tr key={idx} className="border-bottom">
                  <td style={{ ...tableStyles.cell, minWidth: 70 }} className="py-2 px-3 text-center">
                    {idx + 1}
                  </td>
                  <td style={{ ...tableStyles.cell, minWidth: 200 }} className="py-2 px-3 text-center">
                    {bag?.bag_no || "-"}
                  </td>
                  <td style={{ ...tableStyles.cell, minWidth: 150 }} className="py-2 px-3 text-center">
                    {bag.total_quantity || "-"}
                  </td>
                  <td style={{ ...tableStyles.cell, minWidth: 150 }} className="py-2 px-3 text-center">
                    {bag?.dispatch_quantity || "-"}
                  </td>
                  <td style={{ ...tableStyles.cell, minWidth: 150 }} className="py-2 px-3 text-center">
                    {getStatusBadge(bag.status || null)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0 d-flex justify-content-center">
        <CancelBackButton
          label="Close"
          onClick={handleClose}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ViewBagsModal;

